import * as React from 'react';
import { Link } from 'react-router-dom';
import { SalesReport } from '../sales-report';
import * as dateFormat from 'dateformat';
import { ProfileContext } from '../profile';

export interface Props {
  report: SalesReport;
  index: number;
}

const DATE_FORMAT = 'mmmm yyyy';

const getPrice = (value: number, currency: string) => (
  <React.Fragment>
    {currency}&nbsp;{(value / 100).toFixed(2)}
  </React.Fragment>
);

export default function SalesReportListItem(props: Props) {
  const { profile } = React.useContext(ProfileContext);
  const { currency } = profile.company;

  return (
    <div
      className={`flex justify-stretch items-center pv2 pv3-ns ${
        props.index > 0 ? 'bt b--black-10' : ''
      }`}
    >
      <div className="flex-auto">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Report Date</h4>
        <p className="lh-title ma0 black truncate ttu f6 b">
          {dateFormat(props.report.period_start, DATE_FORMAT)}
        </p>
      </div>
      <div className="flex-auto">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Orders</h4>
        <p className="lh-title ma0 black truncate ttu f6 b">
          {props.report.line_items.length}
        </p>
      </div>
      <div className="flex-auto">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Net Total</h4>
        <p className="lh-title ma0 black truncate ttu f6 b">
          {getPrice(props.report.total.net_total_pence, props.report.total.currency)}
        </p>
      </div>
      <div className="flex-auto">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Shipping Total</h4>
        <p className="lh-title ma0 black truncate ttu f6 b">
          {getPrice(props.report.total.shipping_total_pence, props.report.total.currency)}
        </p>
      </div>
      <div className="flex-auto">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Proceeds Total</h4>
        <p className="lh-title ma0 black truncate ttu f6 b">
        {getPrice(props.report.total.proceeds_total_pence + props.report.total.shipping_total_pence, props.report.total.currency)}
        </p>
      </div>
      <div className="tc ml4">
        <Link
          to={{
            pathname: `/sales-reports/${props.report.id}`,
            state: {
              report: props.report,
            },
          }}
          className="link black underline b dim"
        >
          View
        </Link>
      </div>
    </div>
  );
}
